<template>
  <f7-page :page-content="false">
    <f7-navbar title="Tipos de clasificación" :back-link="$t('atras')"></f7-navbar>
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="ItemTipoClasificacion"
        :tableCode="'ITEMS_TIPOS_CLASIFICACION'"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :massiveActions="true"
        :controlsWidth="100"
      >
        <template v-slot:tableLinks>
          <a class="link" href="/itemtipoclasificacion/new/">{{$t('common.nueva')}}</a>
        </template>
        <template v-slot:column-colorBadge="{item}">
          <span
            v-if="item.colorBadge"
            :class="'badge color-' + item.colorBadge"
            :title="item.colorBadge"
            style="padding:4px 12px;border-radius:4px;display:inline-flex;align-items:center;justify-content:center;font-weight:600;letter-spacing:0.3px;min-width:90px;text-align:center;"
          >{{ item.colorBadge }}</span>
        </template>
        <template v-slot:optionsColumn="{item}">
          <f7-link icon-f7="eye" color="green" :href="`/itemtipoclasificacion/view/${encodeURIComponent(item.id)}/`" v-tooltip="$t('common.ver')"></f7-link>
          <f7-link icon-f7="square_pencil" color="blue" :href="`/itemtipoclasificacion/edit/${encodeURIComponent(item.id)}/`" v-tooltip="$t('common.editar')"></f7-link>
          <f7-link icon-f7="trash" color="red" @click="$refs.rlist.deleteItem(item.id)" v-tooltip="$t('common.eliminar')"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
  </f7-page>
</template>

<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import ItemTipoClasificacion from "./../../js/db/ItemTipoClasificacion.js";
import NaturalezasMaestro from "./../../js/utils/naturalezasMaestro.js";

export default {
  components: {
    rDynamicList
  },
  data() {
    return {
      ItemTipoClasificacion,
      encodeURIComponent
    };
  },
  mounted() {
    this.aplicarNaturalezasDelMaestro();
  },
  methods: {
    aplicarNaturalezasDelMaestro() {
      const self = this;
      Promise.all([
        NaturalezasMaestro.load(),
        self.esperarColumnasCargadas()
      ]).then(function (results) {
        var m = results[0];
        if (!m || !m.items || !m.items.length) return;
        var rlist = self.$refs.rlist;
        if (!rlist || !rlist.columns) return;
        var col = rlist.columns.find(function (c) { return c.pathName === 'naturalezaDefault'; });
        if (!col) return;

        col.colores = m.items.map(function (n) {
          return { nombre: n.valor, valor: n.badgeColor || 'gray' };
        }).concat([{ nombre: 'DEFAULT', valor: 'gray' }]);

        if (col.filtro) {
          col.filtro.items = m.items.map(function (n) {
            return { nombre: n.label, valor: n.valor };
          });
        }
        if (rlist.$forceUpdate) rlist.$forceUpdate();
        self.$forceUpdate();
      }).catch(function () { /* silencio: si falla, queda lo del JSON */ });
    },
    esperarColumnasCargadas() {
      const self = this;
      return new Promise(function (resolve) {
        var tries = 0;
        var check = function () {
          var rlist = self.$refs.rlist;
          if (rlist && Array.isArray(rlist.columns) && rlist.columns.length > 0) return resolve();
          if (++tries > 100) return resolve();
          setTimeout(check, 100);
        };
        check();
      });
    }
  }
};
</script>
